import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";

class StatusTag extends Component {
  render() {
    const { type, lables } = this.props;

    const statusMap = {
      "cancel.delivery.message": {
        label: commonUtil.getLabel(lables.EventAdminPage,"cancel.delivery.message"),
        color: "#FF0000",
        shape: "circle",
      },
      "store.delivery.message": {
        label: commonUtil.getLabel(lables.EventAdminPage,"store.delivery.message"),
        color: "var(--main-color-brand)",
        shape: "circle",
      },
      "electronic.delivery.message": {
        label: commonUtil.getLabel(lables.EventAdminPage,"electronic.delivery.message"),
        color: "#0ABD3E",
        description: "Recibes el dinero como saldo en tu monedero.",
        noDot: true, // Important flag to suppress dot
        icon: "monetization_on.svg"
      },
      "physical": {
        label: commonUtil.getLabel(lables.EventAdminPage,"physical.gift"),
        color: "#0ABD3E",
        noDot: true, // Important flag to suppress dot
        icon: "home.svg"
      },
      "return.delivery.message": {
        label: commonUtil.getLabel(lables.EventAdminPage,"return.delivery.message"),
        color: "#FF0000",
        shape: "circle",
      },
      "return.reinvested.delivery.message": {
        label: commonUtil.getLabel(lables.EventAdminPage,"return.reinvested.delivery.message"),
        color: "#07862C",
        shape: "circle",
      },
      "electronic.conversion.message": {
        label: commonUtil.getLabel(lables.EventAdminPage,"electronic.conversion.message"),
        color: "#0ABD3E",
        shape: "circle",
      },
    };

    const current = statusMap[type] || statusMap["cancel.delivery.message"];

    return (
      <div className="status-tag-wrapper">
        {!current.noDot && (
          <div
            className={`status-tag-content ${current.shape}`}
            data-tipo={type}
          >
            <div className="status-tag-icon-wrapper">
              <div
                className={`status-tag-dot ${current.shape}`}
                style={{ backgroundColor: current.color }}
              />
            </div>
            <div className="status-tag-label" style={{ color: current.color }}>
              {current.label}
            </div>
          </div>
        )}

        {(current.description || current.icon) && (
          <div className="status-description-wrapper">
            <div className="status-description-left">
              <img
                src={commonUtil.getAssetURL() + `/images/${current.icon}`}
                alt="monetization on"
              />
              <span
                className="status-description-highlight"
                style={{ color: current.color }}
              >
                {current.label}{current.description ? ":" : ""}
              </span>
            </div>
            {current.description && <div className="status-description-text">{current.description}</div>}
          </div>
        )}
      </div>
    );
  }
}

export default StatusTag;
